/* REDUX */
import { checkAccess } from 'app/actions/app.actions';
import { setDirtyForm } from 'app/actions/dirty-forms.actions';
import { deleteWidget } from 'dashboard/actions/dashboard.actions';

const DIRTY_FORM = 'dashboard';

const mapDispatchToThis = {
  deleteWidget,
  setDirtyForm,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class RwRenderWidgetController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(null, mapDispatchToThis)(this);
    this.DIRTY_FORM = DIRTY_FORM;
    this.cachedImages = {};
  }

  $onDestroy() {
    this.unsubscribe();
  }

  getWidgetConfig() {
    return this.widgetsConfig ? this.widgetsConfig.find((conf) => conf.type === this.widget.type) : {};
  }

  removeWidget() {
    this.deleteWidget(this.widget);
    this.setDirtyForm(DIRTY_FORM, true);
  }

  revokeUrls() {
    Object.keys(this.cachedImages).forEach((url) => {
      URL.revokeObjectURL(url);
    });
  }
}

function RwRenderWidgetDirective($compile) {
  function getComponent(ctrl) {
    const widgetConfig = ctrl.getWidgetConfig();
    return ctrl.checkAccess(widgetConfig.permission) ? widgetConfig.component : '';
  }

  function link(scope, element, attrs, $ctrl) {
    const widgetScope = scope.$new();

    widgetScope.$on('$destroy', () => $ctrl.revokeUrls());
    const widgetComponent = getComponent($ctrl);
    element.html(widgetComponent);
    $compile(element.contents())(widgetScope);
  }

  return {
    controller: RwRenderWidgetController,
    controllerAs: '$ctrl',
    scope: {},
    bindToController: {
      widget: '<',
      isEditMode: '<',
      isDisabledShare: '<',
      widgetsConfig: '<',
      widgetPosition: '<',
      onRemoveWidget: '&',
    },
    link,
  };
}

RwRenderWidgetDirective.$inject = ['$compile'];

export default RwRenderWidgetDirective;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/rw-render-widget/rw-render-widget-directive.js